import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import measureModeDux from 'src/redux/measureMode';
import appDux from 'src/redux/app/';
import Spinner from 'src/components/Spinner';
import utils from 'src/utils';
import { Header } from 'src/components/Sidebar/styled';
import MeasureCategory from './MeasureCategory';
import MeasureExtendedSidebar from './MeasureExtendedSidebar/MeasureExtendedSidebar';
import {
  MeasureCategoryContainer,
  MeasureSidebarContainer,
  JobType,
} from './styled';

const { getPropertyTypeName } = utils.property;

const mapStateToProps = (state) => ({
  measurements: measureModeDux.selectors.getMeasurements(state),
  activeCategoryName: measureModeDux.selectors.getActiveMeasurementCategory(
    state,
  ),
  jobDetails: appDux.selectors.getJobDetails(state),
  isInitialized: state.designPro.app.initialized,
});

export class MeasureSidebar extends PureComponent {
  static propTypes = {
    measurements: PropTypes.object.isRequired,
    jobDetails: PropTypes.object.isRequired,
    activeCategoryName: PropTypes.string.isRequired,
  };

  renderHeader() {
    const { jobDetails } = this.props;

    return (
      <Header>
        All Measurements
        <JobType data-selenium="jobTypeText">
          <span>{getPropertyTypeName(jobDetails.deliverable_id)}</span>
        </JobType>
      </Header>
    );
  }

  renderCategories() {
    const { activeCategoryName, measurements } = this.props;

    const measurementsCategories = Object.keys(measurements);

    return (
      <MeasureCategoryContainer>
        <div>
          {measurementsCategories.map((categoryName) => {
            const categoryData = measurements[categoryName];

            return categoryData.total.count ? (
              <MeasureCategory
                {...categoryData}
                selected={activeCategoryName === categoryName}
                categoryName={categoryName}
              />
            ) : null;
          })}
        </div>
      </MeasureCategoryContainer>
    );
  }

  render() {
    const { measurements, isInitialized } = this.props;
    const measurementsCategories = Object.keys(measurements);

    const shouldShowSpinner =
      !isInitialized || measurementsCategories.length === 0;

    return (
      <MeasureSidebarContainer data-selenium="measureSidebar">
        {this.renderHeader()}
        {shouldShowSpinner && <Spinner color="#767676" />}
        {this.renderCategories()}
        <MeasureExtendedSidebar />
      </MeasureSidebarContainer>
    );
  }
}

export default connect(mapStateToProps)(MeasureSidebar);
